import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

import VueHead from "vue-head";

Vue.use(VueHead);



Vue.use(VueRouter)

  const routes = [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/order",
      name: "basket",
      component: () =>
        import( /* webpackChunkName: "basket" */ "../views/Basket.vue"),
    },
    {
      path: "/order/cakes/edit/:id",
      name: "edit-cake",
      component: () =>
        import(/* webpackChunkName: "cakes" */ "../views/Cakes.vue"),
    },
    {
      path: "/order/cakes",
      name: "add-cake",
      component: () =>
        import(/* webpackChunkName: "cakes" */ "../views/Cakes.vue"),
    },
    {
      path: "/order/christmas-cakes",
      name: "add-special-cake",
      props: {
        defaultGroups: ['christmas-swirl','christmas-ganache']
      },
      component: () =>
        import(/* webpackChunkName: "cakes" */ "../views/Cakes.vue"),
    },
    {
      path: "/order/cupakes/edit/:id",
      name: "edit-cupcakes",
      component: () =>
        import(/* webpackChunkName: "cupcakes" */ "../views/Cupcakes.vue"),
    },
    {
      path: "/order/cupcakes",
      name: "add-cupcakes",
      component: () =>
        import(/* webpackChunkName: "cupcakes" */ "../views/Cupcakes.vue"),
    },
    // {
    //   path: "/order/mothersday-cupcakes",
    //   name: "add-special-cupcakes",
    //   props: {
    //     defaultGroups: ['mothers-mini','mothers-big'],
    //   },
    //   component: () =>
    //     import(/* webpackChunkName: "cupcakes" */ "../views/Cupcakes.vue"),
    // },
    {
      path: "/order/fathersday-cupcakes",
      name: "add-special-cupcakes",
      props: {
        defaultGroups: ['fathers-mini','fathers-big'],
      },
      component: () =>
        import(/* webpackChunkName: "cupcakes" */ "../views/Cupcakes.vue"),
    },
    // {
    //   path: "/order/halloween-cupcakes",
    //   name: "add-special-cupcakes",
    //   props: {
    //     defaultGroups: ['halloween-mini','halloween-big'],
    //   },
    //   component: () =>
    //     import(/* webpackChunkName: "cupcakes" */ "../views/Cupcakes.vue"),
    // },
    // {
    //   path: "/order/valentines-cupcakes",
    //   name: "add-special-cupcakes",
    //   props: {
    //     defaultGroups: ['valentines-mini','valentines-big'],
    //   },
    //   component: () =>
    //     import(/* webpackChunkName: "cupcakes" */ "../views/Cupcakes.vue"),
    // },    
    // {
    //   path: "/order/christmas-cupcakes",
    //   name: "add-special-cupcakes",
    //   props: {
    //     defaultGroups: ['christmas-mini','christmas-big'],
    //   },
    //   component: () =>
    //     import(/* webpackChunkName: "cupcakes" */ "../views/Cupcakes.vue"),
    // },
    {
      path: "/faq",
      name: "faq",
      component: () => import(/* webpackChunkName: "faq" */ "../views/Faq.vue"),
    },
    {
      path: "/about",
      name: "about",
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/About.vue"),
    }, {
      path: "/mailing-list",
      name: "mailing-list",
      component: () =>
        import( /* webpackChunkName: "mailing-list" */ "../views/JoinMailing.vue"),
    },
    {
      path: "/allergies",
      name: "allergies",
      component: () =>
        import(/* webpackChunkName: "allergy" */ "../views/Allergy.vue"),
    },
    {
      path: "/privacy",
      name: "privacy",
      component: () =>
        import(/* webpackChunkName: "privacy" */ "../views/Privacy.vue"),
    },
    {
      path: "/flavours",
      name: "flavours",
      component: () =>
        import(/* webpackChunkName: "flavours" */ "../views/Flavours.vue"),
    }, {
      path: "/thanks/:reference/:date/christmas",
      name: "thanks-christmas",
      component: () =>
        import( /* webpackChunkName: "thanksSpecial" */ "../views/ThanksSpecial.vue"),
    },
    {
      path: "/thanks/:reference/:date",
      name: "thanks",
      component: () =>
        import(/* webpackChunkName: "thanks" */ "../views/Thanks.vue"),
    }, {
      path: "/thanks-email",
      name: "thanks-email",
      component: () =>
        import( /* webpackChunkName: "thanksEmail" */ "../views/ThanksEmail.vue"),
    }
  ];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
